import { Tabs } from "antd";
import ServiceEntry from "./Service Entry/ServiceEntry";
import ServiceRecord from "./ServiceRecord";
import ServiceVoucher from "./ServiceVoucher";
import { useLocation } from "react-router-dom";
import { accessChecker } from "../../../lib/functions";


const Service = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const activeTab = params.get("tab") || "entry";

  const menuData = [
    {
      label: "Service Entry",
      key: "entry",
      value: "service_entry",
      children: (
        <>
          <ServiceEntry />
        </>
      ),
    },
    {
      label: "Service Record",
      key: "record",
      value: "service_record",
      children: (
        <>
          <ServiceRecord />
        </>
      ),
    },
    {
      label: "Service Voucher",
      key: "voucher",
      value: "service_voucher",
      children: (
        <>
          <ServiceVoucher />
        </>
      ),
    },
  ];

  const filteredMenuData = menuData.filter((menuItem) => accessChecker(menuItem.value));

  return (
    <Tabs
      defaultActiveKey={activeTab}
      type="card"
      size="medium"
      style={{ marginBottom: 32 }}
      items={filteredMenuData}
    />
  );
};

export default Service;
